/**
 * Firebase (lazy) — only initialized if the required env vars are present.
 * When they're missing the scaffold falls back to MOCK auth (see auth.jsx).
 */
import { initializeApp, getApps } from "firebase/app";
import {
  getAuth,
  GoogleAuthProvider,
  signInWithPopup,
  signOut as fbSignOut,
} from "firebase/auth";

const config = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

export const isFirebaseConfigured = Boolean(
  config.apiKey && config.authDomain && config.projectId,
);

let _app = null;
let _auth = null;

function ensure() {
  if (!isFirebaseConfigured) {
    throw new Error("Firebase non configurato. Aggiungi le REACT_APP_FIREBASE_* in frontend/.env");
  }
  if (!_app) {
    _app = getApps()[0] || initializeApp(config);
    _auth = getAuth(_app);
  }
  return _auth;
}

export async function signInWithGoogle() {
  const auth = ensure();
  const provider = new GoogleAuthProvider();
  const result = await signInWithPopup(auth, provider);
  const idToken = await result.user.getIdToken();
  return { email: result.user.email, idToken };
}

export async function signOutFirebase() {
  if (!isFirebaseConfigured) return;
  const auth = ensure();
  await fbSignOut(auth);
}
